import React from 'react';
import { useIntl } from '../../../../util/reactIntl';

import css from './SearchMapCurrentLocationPin.module.css';

/**
 * Map pin shown at the user's current / search origin location.
 *
 * @component
 */
const SearchMapCurrentLocationPin = () => {
  const intl = useIntl();
  const label = intl.formatMessage({ id: 'ListingPage.currentLocationPin' });

  return (
    <div className={css.root} role="img" aria-label={label} title={label}>
      <span className={css.pinHead} />
      <span className={css.pinPoint} />
    </div>
  );
};

export default SearchMapCurrentLocationPin;
